import { NgModule } from '@angular/core';
import { PersonsStoreService } from './persons-store.service';

@NgModule({
  imports: [],
  providers: [PersonsStoreService],
  exports: [],
})
export class PersonsStoreModule {}
